// Captive portal so'rov parametrlari — MikroTik `login.html` dan keladi
// (`xsib-core/docs/09-VENUE-PORTAL.md` §9, 3-qadam):
//
//   https://portal.../p?mac=$(mac)&ip=$(ip)&nasid=$(identity)&orig=$(link-orig)
//
// ⚠️ `loginUrl` HUJJATDA YO'Q. §9 faqat to'rtta parametrni sanaydi (mac,
// ip, nasid, orig) — ular orasida MikroTik hotspotning HAQIQIY login POST
// manzili ($(link-login-only)) yo'q. Usiz brauzer 9→10-qadamda (parolni
// MikroTik formasiga yuborish) UNI QAYERGA yuborishni bilmaydi: hujjatdagi
// "MikroTik hotspot login.html'ni o'zi beradi, unga $(mac)... qo'yadi"
// gapi faqat ROUTER ICHIDAGI shablonga tegishli — bizning TASHQI portal
// sahifamiz `$(link-login-only)` qiymatini faqat u ham query parametr
// sifatida uzatilsa biladi.
//
// Bu — kod bilan yopib bo'lmaydigan, HUJJATLASHTIRILMAGAN infratuzilma
// bog'liqligi (router konfiguratsiyasi kerak, frontend kodi emas). Shuning
// uchun taxmin qilinmadi: kod `loginUrl` (yoki MikroTik konventsiyasidagi
// `link-login-only`) parametrini talab qiladi va u yo'q bo'lsa ANIQ xato
// ko'rsatadi (`error.loginTargetMissing`) — hech qayerga yubormaydigan
// "muvaffaqiyat" ekranini ko'rsatishdan ko'ra.
import { normalizeHexBytes, type ChapChallenge } from './chap'

export interface PortalParams {
  /** Qurilma MAC manzili — XOM holicha, backend qayta normallashtiradi */
  mac: string
  /** Mehmon qurilmasiga MikroTik bergan IP — OTP chastota tekshiruvi uchun */
  ip: string | null
  /** MikroTik `/radius` dagi `identity` — `GET /api/portal/zone` shu bo'yicha zonani topadi */
  nasIdentifier: string
  /** Mehmon avval ochmoqchi bo'lgan sahifa — kirishdan keyin `dst` sifatida qaytariladi */
  orig: string | null
  /** ⚠️ Hujjatda yo'q — yuqoridagi izohga qarang */
  loginUrl: string | null
  /** MikroTik `$(chap-id)`/`$(chap-challenge)` HEX ko'rinishida; yo'q bo'lsa parol ochiq (PAP) yuboriladi */
  chap: ChapChallenge | null
}

/**
 * URL so'rov satridan portal parametrlarini o'qiydi.
 *
 * @returns `null` — sahifa MikroTik orqali emas, to'g'ridan-to'g'ri
 *          (masalan xatolik bilan) ochilgan. Bu holatda mehmonga
 *          identifikatsiya ekrani ko'rsatishning ma'nosi yo'q: `mac` yoki
 *          `nasIdentifier` bo'lmasa, hech qanday so'rov muvaffaqiyatli
 *          bo'lolmaydi.
 */
export function parsePortalParams(search: string): PortalParams | null {
  const params = new URLSearchParams(search)
  const mac = params.get('mac')?.trim()
  const nasIdentifier = params.get('nasid')?.trim()
  if (!mac || !nasIdentifier) return null

  return {
    mac,
    ip: params.get('ip')?.trim() || null,
    nasIdentifier,
    orig: params.get('orig')?.trim() || null,
    loginUrl: params.get('loginUrl')?.trim() || params.get('link-login-only')?.trim() || null,
    chap: chapFrom(params),
  }
}

function chapFrom(params: URLSearchParams): ChapChallenge | null {
  const id = normalizeHexBytes(params.get('chapId'))
  const challenge = normalizeHexBytes(params.get('chapChallenge'))
  return id && challenge ? { id, challenge } : null
}
